import React, { forwardRef, useState, InputHTMLAttributes } from 'react';

type PasswordInputProps = InputHTMLAttributes<HTMLInputElement> & {
  invalid?: boolean;
};

const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ invalid, style, ...rest }, ref) => {
    const [show, setShow] = useState(false);

    return (
      <div style={{ position: 'relative' }}>
        <input
          {...rest}
          ref={ref}
          type={show ? 'text' : 'password'}
          aria-invalid={invalid || undefined}
          className="app-input"
          style={{
            width: '100%',
            background: '#2a2a2a',
            border: `1px solid ${invalid ? '#f44336' : '#4a4a4a'}`,
            borderRadius: '4px',
            color: '#ffffff',
            padding: '10px 56px 10px 12px',
            fontSize: '14px',
            outline: 'none',
            ...style,
          }}
        />
        <button
          type="button"
          onClick={() => setShow((s) => !s)}
          aria-label={show ? 'Hide password' : 'Show password'}
          aria-pressed={show}
          style={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'none',
            border: 'none',
            color: '#888888',
            cursor: 'pointer',
            fontSize: '12px',
            padding: '4px',
          }}
        >
          {show ? 'Hide' : 'Show'}
        </button>
      </div>
    );
  }
);

PasswordInput.displayName = 'PasswordInput';

export default PasswordInput;
